<!--
  ~ Copyright (c) 2019. ProVision Media Group Ltd. <https://provision.bg>
  ~ Venelin Iliev <http://veneliniliev.com>
  -->

<div class="modal-header">
  <h4 class="modal-title">
    <span *ngIf="venue && venue.id">{{ 'VENUES.VENUES_FORM.EDIT' | translate }}</span>
    <span *ngIf="!venue || !venue.id">{{ 'VENUES.VENUES_FORM.ADD' | translate }}</span>
  </h4>
  <button type="button" class="close btn-close-templates" aria-label="Close" (click)="modal.dismiss('Cross click')">
    <span aria-hidden="true">&times;</span>
  </button>
</div>

<ng-scrollbar class="modal-body ps">
  <form id="venue-form" (ngSubmit)="save()" [formGroup]="form" novalidate>
    <div class="row">
      <div class="col-sm-6">
        <!-- needs to be updated with @angular/google-maps -->
        <google-map
          *ngIf="form && form.get('lat').value && form.get('long').value"
          class="agm-map"
          height="505px"
          [center]="{
            lat: number(this.form.get('lat').value),
            lng: number(this.form.get('long').value),}
          ">
          <map-marker
            [position]="{
            lat: number(this.form.get('lat').value),
            lng: number(this.form.get('long').value),}
            "
            [title]="this.form.value.name"
            [options]="{draggable: true }"
            (mapDragend)="selectLocation($event)"
          >
          </map-marker>
        </google-map>
        <div class="map-placeholder" *ngIf="!form?.get('lat')?.value || !form?.get('long')?.value"></div>
      </div>
      <div class="col-sm-6">
        <div class="row align-items-center">
          <div class="col-sm-4">
            <app-image-input [form]="form" controlName="logo" newControlName="new_logo"></app-image-input>
          </div>
          <div class="col-sm-8">
            <div class="form-group">
              <label>{{ 'VENUES.VENUES_FORM.NAME' | translate }}</label>
              <input type="text" class="form-control" formControlName="name" />
            </div>
            <div class="form-group">
              <app-cities-select
                [parentFormGroup]="form"
                [fillParentFormCoordinates]="fillParentFormCoordinates"
                #citySelect
              ></app-cities-select>
            </div>
          </div>
        </div>

        <div class="form-group">
          <label>{{ 'VENUES.VENUES_FORM.ADDRESS' | translate }}</label>
          <div class="input-group">
            <app-google-places-autocomplete (placeSelected)="handleAddressChange($event)"
                                            [initialValue]="form.get('address').value"
                                            [countryCode]="venue.city?.country?.code"
            ></app-google-places-autocomplete>
            <div class="input-group-append">
              <button
                type="button"
                class="input-group-text btn btn-primary"
                (click)="fillCoordinates()"
                [attr.disabled]="!lastGPCoordinates['lat'] && !lastGPCoordinates['long'] ? 'disabled' : null"
              >
                <i class="fal fa-search"></i>
              </button>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-sm-6">
            <div class="form-group">
              <label>{{ 'VENUES.VENUES_FORM.LAT' | translate }}</label>
              <input type="number" class="form-control" formControlName="lat" />
            </div>
          </div>
          <div class="col-sm-6">
            <div class="form-group">
              <label>{{ 'VENUES.VENUES_FORM.LONG' | translate }}</label>
              <input type="number" class="form-control" formControlName="long" />
            </div>
          </div>

          <div class="col-sm-3">
            <div class="form-group">
              <label>{{ 'VENUES.VENUES_FORM.DISTANCE_TO_CENTER' | translate }}</label>
              <input type="number" class="form-control" formControlName="distance_to_center" />
            </div>
          </div>

          <div class="col-sm-3">
            <div class="form-group">
              <label>{{ 'VENUES.VENUES_FORM.DISTANCE_TO_AIRPORT' | translate }}</label>
              <input type="number" class="form-control" formControlName="distance_to_airport" />
            </div>
          </div>

          <div class="col-sm-3">
            <div class="form-group">
              <label>{{ 'VENUES.VENUES_FORM.DISTANCE_TO_TR_POINT' | translate }}</label>
              <input type="number" class="form-control" formControlName="distance_to_tr_point" />
            </div>
          </div>

          <div class="col-sm-3">
            <div class="form-group">
              <label>{{ 'VENUES.VENUES_FORM.DISTANCE_TO_TR_POINT_NAME' | translate }}</label>
              <input type="text" class="form-control" formControlName="distance_to_tr_point_name" />
            </div>
          </div>

          <div class="col-sm-3">
            <div class="form-group">
              <label>{{ 'VENUES.VENUES_FORM.FOUNDED_AT' | translate }}</label>
              <input type="text" class="form-control" formControlName="founded_at" />
            </div>
          </div>
          <div class="col-sm-3">
            <div class="form-group">
              <label>{{ 'VENUES.VENUES_FORM.ROOMS_COUNT' | translate }}</label>
              <input type="number" class="form-control" formControlName="rooms_count" />
            </div>
          </div>
          <div class="col-sm-3">
            <div class="form-group">
              <label>{{ 'VENUES.VENUES_FORM.VISITORS_PER_YEAR' | translate }}</label>
              <input type="text" class="form-control" formControlName="visitors_per_year" />
            </div>
          </div>
          <div class="col-sm-3">
            <div class="form-group">
              <label>{{ 'VENUES.VENUES_FORM.AREA' | translate }}</label>
              <input type="text" class="form-control" formControlName="area" />
            </div>
          </div>
          <div class="col-sm-3">
            <div class="form-group">
              <label>{{ 'VENUES.VENUES_FORM.CAPACITY' | translate }}</label>
              <input type="text" class="form-control" formControlName="capacity" />
            </div>
          </div>
          <div class="col-sm-3">
            <div class="form-group">
              <label>{{ 'VENUES.VENUES_FORM.PARKING' | translate }}</label>
              <input type="text" class="form-control" formControlName="parking" />
            </div>
          </div>
        </div>

        <div class="form-group">
          <label>{{ 'VENUES.VENUES_FORM.NOTE' | translate }}</label>
          <textarea
            class="form-control note-textarea"
            formControlName="note"
            [rows]="4"
            [cols]="30"
            pInputTextarea
            autoResize="true"
          ></textarea>
        </div>

        <div class="form-group form-check">
          <input type="checkbox" class="form-check-input" formControlName="active" id="active" />
          <label class="form-check-label" for="active">{{ 'VENUES.VENUES_FORM.ACTIVE' | translate }}</label>
        </div>
      </div>
    </div>
  </form>
</ng-scrollbar>

<div class="modal-footer">
  <button type="submit" class="btn btn-outline-dark btn-xs" form="venue-form" [disabled]="form.invalid">
    {{ 'VENUES.VENUES_FORM.SAVE' | translate }}
  </button>
</div>
